<span class="status-label">
    <span
        class="marker"
        [style.background]="statusColor"
        [style.border-left-color]="borderLeftColor"
    ></span>
    <span *ngIf="!!statusLabel" class="status-label-text">{{ statusLabel }}</span>
</span>
